/**
 * RESET CALCULATOR, shared by every HSA Savings layout. The refresh icon is
 * prod's (legacy fa-refresh). Below 992px the text is visually hidden (still
 * the button's accessible name) and the button is the icon alone, with a
 * tooltip on hover/focus (Brad, 2026-10-01) in prod's wording, RESET
 * CALCULATOR (2026-10-09; was "Reset calculator"). Styles:
 * styles.scss (shared); each layout's sheet adds its own look.
 */
export function ResetButton({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <button type="button" className={'hsab-calc-savings__reset' + (className ? ` ${className}` : '')} onClick={onClick}>
      <svg
        className="hsab-calc-savings__reset-icon"
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="hsab-calc-savings__reset-text">RESET CALCULATOR</span>
      <span className="hsab-calc-savings__reset-tip" aria-hidden="true">
        RESET CALCULATOR
      </span>
    </button>
  );
}
